import {createActionThunk} from 'redux-thunk-actions';
import AT from '../actionTypes';

export const setSidebarState = createActionThunk(
    AT.UPDATE_SIDEBAR_STATE,
    (params) => params,
);
